import axios from 'axios';
import { editDeferralQuery } from './queries';

const editDeferral = (model, key) =>
    new Promise((resolve, reject) => {
        const query = editDeferralQuery({ model, key });
        const request = axios.put(query.url, { ...query.body });
        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to edit Deferral'));
            });
    });

export default editDeferral;
